import { ReactElement } from 'react';

import CTAbox from '../../_core/CTAbox/CTAbox';
import { Content } from './components/content';
import { Hero } from './components/hero';
import * as S from './PageContent.styles';

export const AdhdPageContent = (): ReactElement => {
  return (
    <S.Wrapper>
      <Hero />
      <Content />
      <CTAbox />
    </S.Wrapper>
  );
};
